import React, { Component } from 'react';

const styles = {
    box: { 
        marginTop: '15px'
    },
    vid: {
        marginTop: '5px'
    }
}
export default
class WistiaVideo extends Component {

componentWillMount() {
    const script1 = document.createElement("script");
    const script2 = document.createElement("script");

    script1.src = "https://fast.wistia.com/embed/medias/zoys5h3y4h.jsonp";
    script1.async = true;

    script2.src = "https://fast.wistia.com/assets/external/E-v1.js";
    script2.async = true;

    document.body.appendChild(script1);
    document.body.appendChild(script2);
}

render() {
    return (
        <div style={styles.box}>
            Check out our new video for more information and get a free coupon toward your first edit!<br />
            <div style={styles.vid} className="wistia_embed wistia_async_zoys5h3y4h videoFoam=true"/>
        </div>
        );
    };
}


// WEBPACK FOOTER //
// ./src/components/pages/Videos.js